export default __webpack_public_path__ + "1837f8a12d752d310728dbfcb3175c84.svg";